import { ChangeEvent, useContext, useState } from "react";
import "./ChangePasswordUser.scss";
import { Form, Button } from "react-bootstrap";
import { BankUserContext } from "../../bankUserContext";
import { Row } from "reactstrap";
import { toast } from "react-toastify";
import { Container } from "reactstrap";
import { Col } from "reactstrap";
import { ReactComponent as EyeIcon } from "../../images/eyeIcon.svg";
import SpinnerModel from "../../commonfields/SpinnerModel";
import checkmark from "../../images/checkmark.svg";
import Service from "../../services";
import { useNavigate } from "react-router-dom";

const ChangePasswordUser = () => {
  const service = new Service();
  const [newPasswordError, setNewPasswordError] = useState<string | null>(null);
  const [uppercasecolour, setuppercasecolour] = useState<string | null>(null);
  const [numbercolour, setnumbercolour] = useState<string | null>(null);
  const [symbolcolour, setsymbolcolour] = useState<string | null>(null);
  const [min8charcolour, setmin8charcolour] = useState<string | null>(null);
  const [oldPassword, setOldPassword] = useState<string | null>(null);
  const [oldPasswordError, setOldPasswordError] = useState<string | null>(null);
  const [loader, setLoader] = useState(false);
  const [newPassword, setNewPassword] = useState<string | null>(null);
  const [confirmNewPassword, setConfirmNewPassword] = useState<string | null>(
    null
  );
  const [confirmNewPasswordError, setConfirmNewPasswordError] = useState<
    string | null
  >(null);
  const [createAccountdisable, setcreateAccountdisable] =
    useState<boolean>(true);
  const bankUserContext = useContext(BankUserContext);
  const newPassworduppercaseRegex = new RegExp("^(?=.*[A-Z])");
  const newPasswordnumberRegex = new RegExp("^(?=.*[0-9])");
  const newPasswordsymbolRegex = new RegExp("^(?=.*[!@#$%^&*])");
  const newPasswordmin8charRegex = new RegExp("^(?=.{8,})");

  const [show, setShow] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmNewPassword, setShowConfirmNewPassword] = useState(false);
  const [sucessPwd, setSucessPwd] = useState(false);
  const [errormsg, setErrormsg] = useState(false);
  const [reusepwdError, setReusedpwdError] = useState(false);
  const navigate = useNavigate();

  const handleshowhideOldpassword = () => {
    setShow(!show);
  };
  const handleshowhideNewpassword = () => {
    setShowNewPassword(!showNewPassword);
  };
  const handleshowhideConfirmNewpassword = () => {
    setShowConfirmNewPassword(!showConfirmNewPassword);
  };
  const validations = () => {
    if (
      newPassword &&
      confirmNewPassword &&
      uppercasecolour &&
      numbercolour &&
      symbolcolour &&
      min8charcolour &&
      // newPasswordError ===null &&
      confirmNewPasswordError === null
    ) {
      return false;
    } else {
      return true;
    }
  };
  const landingRedirect = () => {
    navigate("/landing")
  };
  const backRedirect = () => {
    navigate(-1);
  };
  const changePassword = () => {
    setLoader(true);
    if (
      uppercasecolour != null &&
      numbercolour != null &&
      symbolcolour != null &&
      min8charcolour != null &&
      confirmNewPasswordError === null
    ) {
      const userData = {
        screen: "LoginPage",
        sections: "ChangePassword",
        oldPassword: oldPassword,
        newPassword: newPassword,
        conformNewPassword: confirmNewPassword,
        userId: bankUserContext?.bankuserDetails?.userId,
        isJsonReturnObject: false,
      };

      service
        .changePassword(userData)
        .then((response: any) => {
          if (response.status === 200) {
            setLoader(false);
            setSucessPwd(true);
          } else {
            setLoader(false);
            // toast.error(
            //   <>
            //     <div className="fileErrorMessage">Something went wrong..</div>
            //   </>
            // );
          }
        })
        .catch((error: any) => {
          if (error.response.data) {
            setLoader(false);
            setReusedpwdError(error.response.data.errorMessage);
          }
        });
    }
  };

  const onChangeField = (e: any, fieldName: any) => {
    if (fieldName === "newPassword") {
      if (e.target.value === "") {
        setNewPasswordError("*Please enter a new password");
        setuppercasecolour(null);
        setnumbercolour(null);
        setsymbolcolour(null);
        setmin8charcolour(null);
      } else if (e.target.value) {
        newPassworduppercaseRegex.test(e.target.value)
          ? setuppercasecolour("green")
          : setuppercasecolour(null);
        newPasswordnumberRegex.test(e.target.value)
          ? setnumbercolour("green")
          : setnumbercolour(null);
        newPasswordsymbolRegex.test(e.target.value)
          ? setsymbolcolour("green")
          : setsymbolcolour(null);
        newPasswordmin8charRegex.test(e.target.value)
          ? setmin8charcolour("green")
          : setmin8charcolour(null);
        setNewPasswordError(null);
        setNewPassword(e.target.value);
      } else {
        setNewPasswordError(null);
        setNewPassword(e.target.value);
      }
      // if(e.target.value !== confirmNewPassword){
      //   setNewPasswordError(null)
      // }
    } else if (fieldName === "confirmNewPassword") {
      if (e.target.value === "") {
        setConfirmNewPasswordError("*Please enter a new password");
      } else if (e.target.value !== newPassword) {
        setConfirmNewPasswordError("New passwords do not match");
        // setReusedpwdError(false)
      } else {
        setConfirmNewPasswordError(null);
        setConfirmNewPassword(e.target.value);
        if (
          newPassword &&
          uppercasecolour &&
          numbercolour &&
          symbolcolour &&
          min8charcolour &&
          newPasswordError === null &&
          confirmNewPasswordError === null
        ) {
          setcreateAccountdisable(false);
        }
      }
    } else if (fieldName === "oldPassword") {
      setOldPassword(e.target.value);
      if (e.target.value === "") {
        setOldPasswordError("*Please enter a password");
      } else {
        setOldPasswordError("");
      }
    }
  };

  return (
    <div className="changePasswordPage">
      {sucessPwd ? (
        <div className="passwordResetContainer">
          <div className="userResetScreens">
            <Container>
              <Row>
                <Col className="chageHeading">Change Password</Col>
              </Row>
              <Row className="checkMark">
                <img src={checkmark} alt="successgreenIcon" />
              </Row>
              <Row>
                <div className="pwdUpdatemsg">Password Updated</div>
              </Row>
              <Row>
                <div className="pwdmsg">
                  <span>Your password has been successfully updated.</span>
                  <p>You do not need to log out of any accounts or devices.</p>
                </div>
              </Row>
              <Row>
                <Col>
                  <div className="dashboard-btn">
                    <Button
                      className="btndashboard"
                      onClick={() => landingRedirect()}
                    >
                      Back
                    </Button>
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        </div>
      ) : (
        <div className="passwordResetContainer">
          <div className="userResetScreens">
            <Container>
              <Row>
                <Col className="chageHeading">Change Password</Col>
              </Row>
              {confirmNewPasswordError ? (
                <Row>
                  <div className="pwdnotmach"> {confirmNewPasswordError}</div>
                </Row>
              ) : reusepwdError ? (
                <Row>
                  <div className="pwdnotmach"> {reusepwdError}</div>
                </Row>
              ) : (
                ""
              )}
              <Row>
                <Col>
                  <Form>
                    <Form.Group controlId="formBasicEmail" className="mb-4">
                      <Form.Label>Current Password</Form.Label>
                      <Form.Control
                        className="changePassword"
                        type={show ? "text" : "password"}
                        placeholder=""
                        onChange={(e: ChangeEvent) =>
                          onChangeField(e, "oldPassword")
                        }
                      />
                      <EyeIcon
                        onClick={handleshowhideOldpassword}
                        className="eyeIconChangePwd"
                      />
                    </Form.Group>
                    <Form.Group
                      controlId="formBasicEmail"
                      className="mb-4 newPwd"
                    >
                      <Form.Label>New Password</Form.Label>
                      <Form.Control
                        className="changePassword"
                        type={showNewPassword ? "text" : "password"}
                        placeholder=""
                        onChange={(e: ChangeEvent) =>
                          onChangeField(e, "newPassword")
                        }
                      />
                      <EyeIcon
                        onClick={handleshowhideNewpassword}
                        className="eyeIconChangePwd"
                      />
                    </Form.Group>
                    <Form.Group
                      controlId="formBasicEmail"
                      className="mb-4 newPwd2"
                    >
                      <Form.Label>Confirm New Password</Form.Label>
                      <Form.Control
                        className="changePassword"
                        type={showConfirmNewPassword ? "text" : "password"}
                        placeholder=""
                        onChange={(e: ChangeEvent) =>
                          onChangeField(e, "confirmNewPassword")
                        }
                      />
                      <EyeIcon
                        onClick={handleshowhideConfirmNewpassword}
                        className="eyeIconChangePwd"
                      />
                    </Form.Group>
                  </Form>
                </Col>
                <Col>
                  <div className="passHintText mb-3">
                    In order to protect your account,<br/> your password
                    must contain at least:{" "}
                  </div>
                  <ul className="passHintChangpwd mb-3">
                    <li className={uppercasecolour !== null ? "green" : ""}>
                      One uppercase
                    </li>
                    <li className={numbercolour ? "green" : ""}>One number</li>
                    <li className={symbolcolour ? "green" : ""}>
                      One symbol
                    </li>{" "}
                    <li className={min8charcolour ? "green" : ""}>
                      8 characters
                    </li>
                  </ul>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className="btnWrapperChangePwd">
                    <Button
                      type="button"
                      className="btn-white btn-submit"
                      disabled={validations()}
                      onClick={() => changePassword()}
                    >
                      Update Password
                    </Button>
                  </div>
                  <div className="cancel">
                    <span onClick={() => backRedirect()}>Cancel</span>
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        </div>
      )}

      {loader ? (
        <SpinnerModel value={""} color={"primary"} size={""} type={"border"} />
      ) : null}
    </div>
  );
};

export default ChangePasswordUser;
